import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from "classnames";
var sizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-12 w-12",
    xl: "h-24 w-24"
};
var variants = {
    light: "text-white",
    primary: "text-blue-600"
};
export function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? "md" : _size, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("svg", {
                className: clsx("animate-spin", sizes[size], variants[variant], className),
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "data-testid": "loading",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: "Loading"
            })
        ]
    });
}
